import { render, staticRenderFns } from "./OrgCreateNew.vue?vue&type=template&id=472d8744&"
import script from "./OrgCreateNew.vue?vue&type=script&lang=js&"
export * from "./OrgCreateNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports